import React from "react";
import { Stage, Layer, Rect, Arrow, Text, Image as KonvaImage } from "react-konva";

const CanvasStage = ({
  image, imageProps, stageRef,
  annotations, setAnnotations,
  newShape, setNewShape,
  isDrawing, setIsDrawing,
  drawMode, selectedId, setSelectedId,
  setLabelPrompt, setPendingShape
}) => {

  const handleMouseDown = (e) => {
    if (drawMode === "select") return; // prevent drawing
  
    if (!isDrawing) {
      const { x, y } = e.target.getStage().getPointerPosition();
      if (drawMode === "rect") {
        setNewShape({ type: "rect", x, y, width: 0, height: 0, label: "" });
      } else if (drawMode === "arrow") {
        setNewShape({ type: "arrow", points: [x, y, x, y], label: "" });
      }
      setIsDrawing(true);
    }
  };
  

  const handleMouseMove = (e) => {
    if (!isDrawing || !newShape) return;
    const { x, y } = e.target.getStage().getPointerPosition();
    if (newShape.type === "rect") {
      setNewShape({ ...newShape, width: x - newShape.x, height: y - newShape.y });
    } else {
      const [x1, y1] = newShape.points;
      setNewShape({ ...newShape, points: [x1, y1, x, y] });
    }
  };

  const handleMouseUp = () => {
    if (newShape) {
      const labelX = newShape.type === "arrow" ? newShape.points[2] : newShape.x + newShape.width / 2;
      const labelY = newShape.type === "arrow" ? newShape.points[3] : newShape.y + newShape.height / 2;
      setLabelPrompt({ visible: true, x: labelX, y: labelY });
      setPendingShape(newShape);
      setNewShape(null);
      setIsDrawing(false);
    }
  };

  return (
    <Stage
      ref={stageRef}
      width={window.innerWidth - 80}
      height={window.innerHeight - 56}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      style={{ cursor: "crosshair" }}
    >
      <Layer>
        {image && <KonvaImage image={image} x={imageProps.x} y={imageProps.y} />}

        {annotations.map((shape, i) => {
          const isSelected = selectedId === i;
          if (shape.type === "arrow") {
            return (
              <React.Fragment key={i}>
                <Arrow
                  points={shape.points}
                  pointerLength={10}
                  pointerWidth={10}
                  fill="green"
                  stroke={isSelected ? "orange" : "green"}
                  strokeWidth={2}
                  onClick={() => setSelectedId(i)}
                />
                {shape.label && (
                  <Text
                    x={shape.points[0] + 4}
                    y={shape.points[1] + 4}
                    text={shape.label}
                    fontSize={14}
                    fontStyle="bold"
                    fill="green"
                  />
                )}
              </React.Fragment>
            );
          }

          return (
            <React.Fragment key={i}>
              <Rect
                x={shape.x}
                y={shape.y}
                width={shape.width}
                height={shape.height}
                stroke={isSelected ? "orange" : "red"}
                strokeWidth={2}
                onClick={() => setSelectedId(i)}
              />
              {shape.label && (
                <Text
                  x={shape.x + 4}
                  y={shape.y + 4}
                  text={shape.label}
                  fontSize={14}
                  fontStyle="bold"
                  fill="red"
                />
              )}
            </React.Fragment>
          );
        })}

        {newShape?.type === "rect" && (
          <Rect
            x={newShape.x}
            y={newShape.y}
            width={newShape.width}
            height={newShape.height}
            stroke="blue"
            strokeWidth={2}
            dash={[4, 4]}
          />
        )}

        {newShape?.type === "arrow" && (
          <Arrow
            points={newShape.points}
            pointerLength={10}
            pointerWidth={10}
            fill="blue"
            stroke="blue"
            strokeWidth={2}
            dash={[4, 4]}
          />
        )}
      </Layer>
    </Stage>
  );
};

export default CanvasStage;
